import { APP_URL } from "../constants";
import { httpClient } from "../utils/http-client";

const authHeaders = (token) => ({
  Authorization: `Bearer ${token}`,
  locale: navigator.language,
});

const fetchTransactionConfigs = async (token, { offset = 0, limit = 1000 } = {}) => {
  try {
    const params = new URLSearchParams({
      page: String(offset),
      size: String(limit),
    });
    return httpClient.get(`${APP_URL}/v1/tx/configs?${params}`, authHeaders(token));
  } catch (error) {
    console.log("Error getting transaction configs", error);
    return error;
  }
};

const addTransactionConfig = async (data, token) => {
  try {
    return await httpClient.postFile(
      `${APP_URL}/v1/tx/configs`,
      data,
      authHeaders(token)
    );
  } catch (error) {
    console.log("Error creating transaction config", error);
    return error;
  }
};

const updateTransactionConfig = async (id, data, token) => {
  try {
    return httpClient.put(
      `${APP_URL}/v1/tx/configs/${id}`,
      data,
      authHeaders(token)
    );
  } catch (error) {
    console.log("Error updating transaction config", error);
    return error;
  }
};

const deleteTransactionConfig = async (id, token) => {
  try {
    return httpClient.delete(
      `${APP_URL}/v1/tx/configs/${id}`,
      authHeaders(token)
    );
  } catch (error) {
    console.log("Error deleting transaction config", error);
    return error;
  }
};

const fetchMerchantTransactionConfigs = async (merchantUserId, token) => {
  try {
    const id = `${merchantUserId ?? ""}`.trim();
    return httpClient.get(
      `${APP_URL}/v1/tx/configs/merchants/${encodeURIComponent(id)}`,
      authHeaders(token)
    );
  } catch (error) {
    console.log("Error getting merchant transaction configs", error);
    return error;
  }
};

const upsertMerchantTransactionConfig = async (merchantUserId, data, token) => {
  try {
    const id = `${merchantUserId ?? ""}`.trim();
    return httpClient.put(
      `${APP_URL}/v1/tx/configs/merchants/${encodeURIComponent(id)}`,
      data,
      authHeaders(token)
    );
  } catch (error) {
    console.log("Error saving merchant transaction config", error);
    return error;
  }
};

export {
  fetchTransactionConfigs,
  fetchMerchantTransactionConfigs,
  addTransactionConfig,
  upsertMerchantTransactionConfig,
  updateTransactionConfig,
  deleteTransactionConfig,
};
